export const API_ENDPOINTS = {
  GET_IV_ItemAttributesBasedMenu: "itemcard/getitemattributesbasedmenu",
  GET_ItemsWithTagList: "itemcard/getitemWithtaglist",
  GET_ItemSearchWithAttributes: "itemcard/getitemsearchwithattributes",
  GET_ItemDetailAndRelatedItems: "itemcard/getitemdetailandrelateditems",
  GET_ItemAndModelWithSearch: "itemcard/getitemandmodelwithsearch",
  POST_AccountLogin: "Accounts/AccountLogin",
  POST_AccountCreation: "Accounts/AccountCreation",
  POST_VerifyOTP: "Accounts/VerifyOTP",
  POST_ResendOTP: "Accounts/ResendOTP",
  GET_UserProfile: "Accounts/UserProfile",
  POST_UserProfile: "Accounts/UserProfile",
  GET_UserAddressList: "useraddress/List",
  GET_UserAddressGet: "useraddress/Get",
  POST_UserAddressPut: "useraddress/Put",
  GET_ResetPassword: "accounts/resetpassword",
  POST_ForgetPassword: "Accounts/ForgetPassword",
  POST_ResendConfirmationEmail: "Accounts/ResendConfirmationEmail",
  POST_Confirm: "Accounts/Confirm",
  POST_ResetPassword: "Accounts/ResetPassword",
  GET_StripeApiKeys: "configuration/stripeapikeys",
  POST_OrderCheckout: "order/checkout",
  POST_CreatePaymentIntent: "order/CreatePaymentIntent",
  POST_ValidateOrderItems: "order/validateorderitems",
  GET_OrderList: "order/list",
  GET_OrderDetail: "order/detail",
  POST_GetShippingRates: "order/GetShippingRates",
};
